export const PRODUCT_UNITS = {
  PIECE: 'piece',
  PAIR: 'pair',
  METER: 'meter',
  SQUARE_METER: 'square_meter',
};

export const PRODUCT_UNIT_VALUES = Object.values(PRODUCT_UNITS);

export function productUnitOptions($t) {
  return [
    { value: null, label: $t('products.units.none') },
    ...PRODUCT_UNIT_VALUES.map((unit) => ({ value: unit, label: $t(`products.units.${unit}`) })),
  ];
}

export function shortUnitLabel(unit, $t) {
  return PRODUCT_UNIT_VALUES.includes(unit) ? $t(`products.units_short.${unit}`) : '';
}
